import React from "react";
import { Route, Routes } from "react-router-dom";
import CommunityLanding from "../views/PostLogin/Community";

const PostLoginRoutes = (props) => {
  return (
    <>
      <Routes>
        <Route path="*" element={<CommunityLanding onChange={props.onChange} />} />
      </Routes>
    </>
  );
};

export default PostLoginRoutes;
